import { render, staticRenderFns } from "./VeJwBkStudentModal.vue?vue&type=template&id=d77f5460"
import script from "./VeJwBkStudentModal.vue?vue&type=script&lang=js"
export * from "./VeJwBkStudentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports